import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { toMuiTheme } from './theme';
export const ThemeProvider = ({ theme, children, localization, LinkBehavior }) => {
    const muiTheme = React.useMemo(() => {
        return toMuiTheme(theme, localization, {
            LinkBehavior,
        });
    }, [theme, localization, LinkBehavior]);
    return _jsx(MuiThemeProvider, { theme: muiTheme, children: children });
};
